<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <span>Vergi Levhası</span>
        <v-file-input
          show-size
          v-model="localData.taxPlate"
          label="Dosya yükle"
          @change="(e) => handleFileChange(e, 'taxPlate')"
          @clear="handleFileClear('taxPlate')"
          accept="image/jpg, image/jpeg, image/png, application/pdf"
          :rules="fileRules"
        ></v-file-input>
      </v-col>
      <v-col cols="12" md="6">
        <span>Faaliyet Belgesi</span>
        <v-file-input
          show-size
          v-model="localData.certificateOfActivity"
          label="Dosya yükle"
          @change="(e) => handleFileChange(e, 'certificateOfActivity')"
          @clear="handleFileClear('certificateOfActivity')"
          accept="image/jpg, image/jpeg, image/png, application/pdf"
          :rules="fileRules"
        ></v-file-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <span>İmza Sirküleri</span>
        <v-file-input
          show-size
          v-model="localData.signatureCircular"
          label="Dosya yükle"
          @change="(e) => handleFileChange(e, 'signatureCircular')"
          @clear="handleFileClear('signatureCircular')"
          accept="image/jpg, image/jpeg, image/png, application/pdf"
          :rules="fileRules"
        ></v-file-input>
      </v-col>
      <v-col cols="12" md="6">
        <span>Ticaret Sicil Kaydı</span>
        <v-file-input
          show-size
          v-model="localData.tradeRegistryRecord"
          label="Dosya yükle"
          @change="(e) => handleFileChange(e, 'tradeRegistryRecord')"
          @clear="handleFileClear('tradeRegistryRecord')"
          accept="image/jpg, image/jpeg, image/png, application/pdf"
          :rules="fileRules"
        ></v-file-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <span>Sözleşme <a href="/files/sozlesme.pdf" download="sozlesme.pdf" style="margin-left: 8px;">İndir</a></span>
        <br />
        <span style="font-size:12px; color:gray;"> Frink Üye İş Yeri Sözleşmesi’ni indirerek imzalamanız ve sonrasında imzalı sözleşmeyi geri yüklemeniz gerekmektedir.</span>

        <v-file-input
          show-size
          v-model="localData.contract"
          label="Dosya yükle"
          @change="(e) => handleFileChange(e, 'contract')"
          @clear="handleFileClear('contract')"
          accept="image/jpg, image/jpeg, image/png, application/pdf"
          :rules="fileRules"
        ></v-file-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "UploadDocsForm",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
      fileRules: [
        (v) => !!v || "Dosya gereklidir.",
        (v) => (v && v.name != null) || "Dosya gereklidir.",
        (v) =>
          !v || v.size <= 10000000 || "Maksimum dosya boyutunu aştınız (10MB).",
      ],
    };
  },
  methods: {
    handleFileChange(file, key) {
      if (file && file.size > 10000000) {
        this.localData[key] = null;
        this.$emit("update-form-data", "uploadDocs", {
          ...this.localData,
          [key]: null,
        });
      } else {
        this.$emit("update-form-data", "uploadDocs", this.localData);
      }
    },
    handleFileClear(key) {
      this.localData[key] = null;
      this.$emit("update-form-data", "uploadDocs", this.localData);
    },
  },
};
</script>
